import V from '../coooders/common/tool';

export const test = async(...p) => {
    await V.each(p, async function(v) {
        console.log(v);
    });
    console.log('end');
};

export default { test };